import { render } from "./auxiliaryScreen.vue?vue&type=template&id=9c6305b2"
import script from "./auxiliaryScreen.vue?vue&type=script&lang=js"
export * from "./auxiliaryScreen.vue?vue&type=script&lang=js"

import "./auxiliaryScreen.vue?vue&type=style&index=0&id=9c6305b2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__